import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './select.module.css'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    selectable: PropTypes.bool,
    selected: PropTypes.bool,
    title: PropTypes.string
}

const defaultProps = {
    changeEvent: 'onClick',
    disabled: false,
    onClick() {},
    selectable: true,
    selected: false
}

function Option(props) {
    const { children, className, disabled, onClick, selectable, selected, title } = props
    const classNameMerged = cx(
        styles['option'],
        {
            [styles['selectable']]: selectable,
            [styles['disabled']]: disabled,
            [styles['selected']]: selected,
            ['t3sel-option-disabled']: disabled,
            ['t3sel-option-selectable']: selectable,
            ['t3sel-option-selected']: selected
        },
        't3sel-option',
        className
    )

    // don't use '' as default, since it will show an empty hint on Edge
    const tooltipText = title || (children && typeof children === 'string' && children) || undefined

    return (
        <li className={classNameMerged} title={tooltipText} {...{ onClick }}>
            <div className={cx(styles['option-content'], 't3sel-option-content')}>{children}</div>
        </li>
    )
}

Option.propTypes = propTypes
Option.defaultProps = defaultProps

export default Option
